<template>
<div>
  <v-alert type="error" v-if="errorAlertVisible">Chyba serveru</v-alert>
  <v-alert type="error" v-if="creditError">
    <v-row align="center">
      <v-col class="grow pa-0">
        Nedostatek kreditu
      </v-col>
      <v-col class="shrink pa-0">
        <v-btn
          small
          depressed
          color="error"
          @click="creditError = false"
        >x</v-btn>
      </v-col>
    </v-row>
  </v-alert>
  <v-alert type="warning" v-if="orderedByUser">Na tento den již objednal uživatel</v-alert>
<v-container>
  <v-row>
    <v-col
    cols="4"
    sm="12"
    md="3"
    >
      <template>
        <v-row justify="center">
          <v-date-picker
            v-model="selectedDate"
            color="red darken-3"
            full-width
          ></v-date-picker>
        </v-row>
      </template>
    </v-col>
    <v-col
      cols="8"
      sm="12"
      md="9"
    >
      <div
        v-for="(time, index) in availableFood"
        :key="index"
      >
        <v-data-table
          v-if="time.length"
          :headers="headers"
          :items="time"
          item-key="name"
          show-expand
          class="elevation-1 order-table"
          hide-default-footer
          disable-sort
          dense
        >
          <template v-slot:top>
            <v-toolbar flat dense>
              <v-toolbar-title>{{timeTypes.length ? timeTypes[index].name : ''}}</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:item.photo="{ /*item*/ }">
            <v-icon
              small
              class="mr-2"
            >
              mdi-camera
            </v-icon>
          </template>
          <template v-slot:item.order="{ item }">
            <v-checkbox
              v-if="item.editable"
              :label="item.selected ? 'Objednáno' : 'Objednat'"
              v-model="item.selected"
              :disabled="disabledDayTimeInputs[index]"
              @change="selectMeal(item)"
            ></v-checkbox>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td
              :colspan="headers.length"
              v-if="item.type === 'App\\Menu'"
            >
              <div
                v-for="(menuItem, index) in item.drinks.concat(item.foods)" :key="index"
              >{{menuItem.name}}</div>
            </td>
            <td
              :colspan="headers.length"
              v-else
            >{{item.name}}</td>
          </template>
        </v-data-table>
      </div>
    </v-col>
  </v-row>
</v-container>
</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'Main',
  data () {
    return {
      errorAlertVisible: false,
      orderedByUser: false,
      creditError: false,
      disabledDayTimeInputs: [],
      items: [[], [], [], [], [], []],
      availableFood: [[], [], [], [], [], []],
      headers: [
        { text: '', value: 'photo', sortable: false },
        {
          text: 'Název',
          align: 'start',
          sortable: false,
          value: 'name',
          width: 300
        },
        { text: 'Alergeny', value: 'alergensStr' },
        { text: 'Kalorie', value: 'calories' },
        { text: 'Cena', value: 'price' },
        { text: '', value: 'order' }
      ],
      diet: {},
      selectedDate: new Date().toISOString().substr(0, 10),
      timeTypes: []
    }
  },
  methods: {
    initialize () {
      this.$http.get('/admin/times')
        .then(response => {
          this.timeTypes = this.keysToCamelCase(response.data)
            .filter(time => time.active)
        })
        .catch(err => {
          console.log(err)
        })
      this.$http.get(`/admin/users/${this.currentUser.id}/diets`)
        .then(response => {
          const tmp = this.keysToCamelCase(response.data[0])
          this.cart.diet = tmp
          this.diet = tmp
          this.getDietDay()
        })
        .catch(err => console.log(err))
    },
    getDietDay () {
      this.reset()
      this.orderedByUser = false
      for (let i = 0; i < 6; i++) {
        this.disabledDayTimeInputs[i] = true
      }

      this.$http.get(`/users/${this.currentUser.userId}`).then(response => {
        this.setUser(this.keysToCamelCase(response.data))
        this.$store.commit('user/storeCredit', response.data.credit)
      })
        .catch(err => console.log(err));

      (new Promise((resolve, reject) => { // send requests, wait for them to resolve
        let order
        let dietDay

        this.$http.get(`/admin/diets/${this.diet.id}/days/date/${this.selectedDate}`)
          .then(res => {
            dietDay = this.keysToCamelCase(res.data)
            if (order !== undefined) {
              resolve({
                order,
                dietDay
              })
            }
          })
          .catch(() => reject(new Error('diet error')))
        this.$http.post('boarder-orders/checkIfOrderDay', {
          date: this.selectedDate
        })
          .then(res => {
            order = this.keysToCamelCase(res.data)
            if (dietDay !== undefined) {
              resolve({
                order,
                dietDay
              })
            }
          })
          .catch(() => reject(new Error('order error')))
      }))
        .then(data => {
          // requesty behaj moc rychle
          /* setTimeout(() => {
            this.creditError = false
          }, 2000) */
          this.errorAlertVisible = false
          const dietDayResponse = data.dietDay
          const orderResponse = data.order
          this.availableFood = [[], [], [], [], [], []]
          if (Array.isArray(dietDayResponse) && !dietDayResponse.length) {
            return
          }

          const itemsAll = dietDayResponse.foods.map(food => ({ ...food, type: 'App\\Food' }))
            .concat(
              dietDayResponse.drinks.map(drink => ({ ...drink, type: 'App\\Drink' })),
              dietDayResponse.menus.map(menu => ({ ...menu, type: 'App\\Menu' })))
            .map(item => {
              item.alergensStr = item.alergens
                .map(allergen => allergen.name)
                .join(', ')
              item.quantity = 1
              item.selected = false
              return item
            })

          this.availableFood = this.availableFood.map((time, index) => {
            const meals = itemsAll.filter(item => item.timeId === index + 1)
            if (meals.length) {
              this.disabledDayTimeInputs[index] = !meals[0].editable // staci zkontrolovat prvni jidlo
            }
            return meals
          })

          if (orderResponse.id) {
            const order = orderResponse
            this.setOrderObject(order)
            this.cart = order

            if (order.isOrderedByUser) {
              this.disabledDayTimeInputs = [true, true, true, true, true, true]
              this.orderedByUser = true
            }

            // map to shopping cart
            if (this.cart.items[this.selectedDate]) {
              this.availableFood = this.availableFood.map((time, index) => {
                if (!this.cart.items[this.selectedDate][index].length) {
                  return time
                } else {
                  return time.map(food => {
                    const shoppingCartFood = this.cart.items[this.selectedDate][index]
                      .find(f => f.id === food.id && f.type === food.type)
                    if (shoppingCartFood) {
                      food.selected = true
                      food.quantity = shoppingCartFood.quantity
                    }
                    return food
                  })
                }
              })
            }
          }
        })
        .catch(err => console.log(err))
    },
    selectMeal (item) {
      // TODO: ordered by user, nevim
      /* if (this.cartOrder.) {
        return
      } */
      this.disabledDayTimeInputs = [true, true, true, true, true, true]
      this.availableFood[item.timeId - 1] = this.availableFood[item.timeId - 1]
        .map(food => {
          if (food !== item) {
            food.selected = false
          }
          return food
        })
      const selectedItems = [[], [], [], [], [], []].map((time, index) => {
        const meal = this.availableFood[index].filter(meal => meal.selected)[0]
        return meal ? [meal] : []
      })
      const orderEmpty = !selectedItems.flat().length

      const requestBody = {
        userId: this.currentUser.userId,
        boarders: [this.currentUser],
        diet: this.diet,
        dietId: this.diet.id,
        deliveryType: 'Rozvoz',
        paymentTypeId: 1,
        customPackaging: 0,
        description: '',
        order: false,
        items: {
          [this.selectedDate]: selectedItems
        }
      }
      let options
      if (orderEmpty) {
        options = {
          method: 'delete',
          url: `/boarder-orders/${this.cartOrder.id}`
        }
      } else {
        options = {
          method: this.cartOrder.id ? 'put' : 'post',
          url: `/boarder-orders${this.cartOrder.id ? '/' + this.cartOrder.id : ''}`,
          data: this.keysToSnakeCase(requestBody)
        }
      }
      this.$http(options)
        .then(response => {
          this.getDietDay()
        })
        .catch(err => {
          if (err.response.status === 400) {
            if (err.response.data.message === 'Not enough credit') {
              this.creditError = true
            }
          } else if (err.response.status >= 500) {
            this.errorAlertVisible = true
          }
          this.getDietDay()
        })
    },
    showErrorAlert () {
      this.errorAlertVisible = true
      setTimeout(() => { this.errorAlertVisible = false }, 3500)
    },
    ...mapMutations({
      reset: 'ordering/reset',
      goToStep: 'ordering/goToOrderingStep',
      setDeliveryInfo: 'ordering/setDeliveryInfo',
      setUser: 'ordering/setUser',
      setOrderObject: 'ordering/setOrderObject'
    })
  },
  computed: {
    totalPrice () {
      const prices = this.orderedItems
        .map(item => {
          if (!item || !item.length) {
            return 0
          } else {
            return item.price
          }
        })
      return prices
        .reduce((prev, next) => {
          return prev + +next
        }, 0)
    },
    ...mapGetters({
      currentUser: 'user/currentUser',
      cart: 'ordering/shoppingCart',
      cartOrder: 'ordering/cartOrder'
    }),
    // vuex bindings
    'cart.diet': {
      get () {
        return this.$store.ordering.state.cart.diet
      },
      set (diet) {
        this.$store.ordering.state.cart.diet = diet
      }
    },
    'cart.order': {
      get () {
        return this.$store.ordering.state.cart.order
      },
      set (user) {
        this.$store.ordering.state.cart.order = !!user
      }
    },
    'cart.boarders': {
      get () {
        return this.$store.ordering.state.cart.boarders
      },
      set (boarders) {
        this.$store.ordering.state.cart.boarders = boarders
      }
    },
    cart: {
      get () {
        return this.$store.state.ordering.cart
      },
      set (cart) {
        this.$store.commit('ordering/setCart', cart)
      }
    }
  },
  watch: {
    selectedDate () {
      this.getDietDay()
    }
  },
  created () {
    for (let i = 0; i < 6; i++) {
      this.disabledDayTimeInputs[i] = false
    }
    this.initialize()
  }
}
</script>

<style scoped>

</style>
